var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-input',{attrs:{"value":_vm.$props.slot_number,"type":"number"},on:{"change":function($event){return _vm.changeSlotNumber($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }